import { Box, Divider, Typography } from "@mui/material";

import { ModalBox } from "components";
import {
  UPLOAD_FOOTER_NOTE,
  UPLOAD_MODAL_SUBTITLE,
  UPLOAD_MODAL_TITLE,
  UPLOAD_SECTIONS,
} from "../constants";
import UploadSectionRow from "./UploadSectionRow";

const UploadDataModal = ({ open, onClose, uploadingKey, onUpload }) => (
  <ModalBox open={open} onCloseModal={onClose} width="600px">
    <Box>
      <Box pb={3}>
        <Typography variant="h5" fontWeight={600} mb={1}>
          {UPLOAD_MODAL_TITLE}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {UPLOAD_MODAL_SUBTITLE.prefix}
          <Box component="span" sx={{ fontWeight: 600, color: "primary.main" }}>
            {UPLOAD_MODAL_SUBTITLE.highlight1}
          </Box>
          {UPLOAD_MODAL_SUBTITLE.middle}
          <Box component="span" sx={{ fontWeight: 600, color: "primary.main" }}>
            {UPLOAD_MODAL_SUBTITLE.highlight2}
          </Box>
          {UPLOAD_MODAL_SUBTITLE.suffix}
        </Typography>
      </Box>
      <Divider sx={{ mb: 3 }} />

      {UPLOAD_SECTIONS.map((section) => (
        <UploadSectionRow
          key={section.key}
          section={section}
          isUploading={uploadingKey === section.key}
          onUpload={onUpload}
        />
      ))}

      <Divider sx={{ my: 2 }} />
      <Typography variant="caption" color="text.secondary">
        {UPLOAD_FOOTER_NOTE}
      </Typography>
    </Box>
  </ModalBox>
);

export default UploadDataModal;
